<template>
    <div>
        <div style="padding:10px 0">
            <el-select v-model="gender" slot="prepend" placeholder="sex selection" @change="search">
                <el-option label="male" value="1"></el-option>
                <el-option label="female" value="0"></el-option>
                <el-option label="all" value=""></el-option>
            </el-select>
            <el-input placeholder="Please enter user number" v-model="userID" suffix-icon="el-icon-search" @change="search" clearable
                style="width: 300px; margin-left: 5px;"></el-input>
            <el-input placeholder="please enter user name" v-model="userName" suffix-icon="el-icon-search" @change="search" clearable
                style="width: 300px; margin-left: 5px;"></el-input>
            <el-input placeholder="Please enter user age" v-model="age" suffix-icon="el-icon-search" @change="search" clearable
                style="width: 300px; margin-left: 5px;"></el-input>

            <el-date-picker style="margin-left:5px" v-model="date" type="daterange" range-separator="to"
                start-placeholder="start date" end-placeholder="end date" format="yyyy-MM-dd" value-format="yyyy-MM-dd" @change="search">
            </el-date-picker>
            <el-button @click="search" style="margin-left:10px" @change="search" type="primary">search</el-button>
        </div>
        <div style="padding-top:5px;padding-bottom: 10px;">
            <el-button type="primary" @click="exportData" icon="el-icon-upload2">Export</el-button>
        </div>
        <el-table :data="tableData" border style="width: 90%" @selection-change="handleSelectionChange">
            <el-table-column type="selection" width="70" align="center">
            </el-table-column>
            <el-table-column prop="userID" label="User ID" width="100" align="center">
            </el-table-column>
            <el-table-column  label="username" align="center" width="250">
                <template slot-scope="scope">
                    {{ getFullName(scope.row) }}
                </template>
            </el-table-column>
            <el-table-column  label="gender" width="100px" align="center">
                <template slot-scope="scope">
                    {{ getGender(scope.row) }}
                </template>
            </el-table-column>
            <el-table-column prop="age" label="age" width="100" align="center">
            </el-table-column>
            <el-table-column prop="createDate" label="Creation date" width="300" align="center">
            </el-table-column>
            <el-table-column fixed="right" label="operate" align = "center">
                <template slot-scope="scope">
                    <el-button style="margin-right:2%" type="success" icon="el-icon-share"
                        @click="switchToMachine(scope.row)" circle></el-button>
                </template>
            </el-table-column>
        </el-table>

        <div style="padding:10px 0">
            <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum"
                :page-sizes="[5, 10, 15, 20]" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper"
                :total="total">
            </el-pagination>
        </div>
    </div>
</template>
<script>
import request from '@/utils/request';
export default {
    data() {
        return {
            breadcrumb_teb: {},
            total:0,
            date: [],
            machine: this.$store.state.teb.machineID,
            gender: "",
            age: "",
            userName: "",
            userID: "",
            firstDate: "",
            lastDate: "",
            form: {
                userID: '',
                firstName: '',
                lastName: '',
                age: '',
                gender: '',
                createDate: ''
            },
            pageNum: 1,
            pageSize: 10,
            tableData: []
        }
    },
    methods: {
        async exportData() {
            try {
                // const url = `https://www.qihang.store/sb/cl4user/export/user?machine=${this.machine}&gender=${this.gender}&userID=${this.userID}&userName=${this.userName}&age=${this.age}&firstDate=${this.firstDate}&lastDate=${this.lastDate}`;
                const url = `http://localhost:1521/sb/cl4user/export/user?machine=${this.machine}&gender=${this.gender}&userID=${this.userID}&userName=${this.userName}&age=${this.age}&firstDate=${this.firstDate}&lastDate=${this.lastDate}`;
                window.open(url);
            } catch (error) {
                console.error("Error:", error);
            }
        },
        switchToMachine(row){
            this.$store.state.teb.cl4UserID = row.userID
            this.$store.state.teb.cls_gender = row.gender
            this.$router.push('/Cl4FaceUserInfo')
        },
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.load();
        },
        handleCurrentChange(pageNum) {
            this.pageNum = pageNum;
            this.load();
        },

        search() {
          this.pageNum =1;
          this.load();
        },
        load() {
            if (this.date && this.date.length > 0) {
                if (this.date[0] && this.date[1]) {
                    this.firstDate = this.date[0];
                    this.lastDate = this.date[1];
                } else {
                    this.firstDate = '';
                    this.lastDate = '';
                }
           }else{
                   this.firstDate = '';
                   this.lastDate = '';
           }
            request.get("/cl4user/selectToUser", {
                params: {
                    machine: this.machine,
                    userID: this.userID,
                    gender: this.gender,
                    age: this.age,
                    userName: this.userName,
                    firstDate: this.firstDate,
                    lastDate: this.lastDate,
                    pageNum: this.pageNum,
                    pageSize: this.pageSize
                }

            }).then(res => {
                const data = res.data || {}
                const isArray = Array.isArray(data)
                this.tableData = isArray ? data : (data.data || [])
                this.total = (isArray ? res.count : data.count) || 0
            })
        },
        handleSizeChange(pageSize) {
            this.pageSize = pageSize;
            this.load();
        },
        handleCurrentChange(pageNum) {
            this.pageNum = pageNum;
            this.load();
        },
        getFullName(row) {
            return row.firstName + ' ' + row.lastName;
        },
        getGender(row){
            if(row.gender ==0){
                return "female"
            }else{
                return "male"
            }
        },
        handleSelectionChange(val){
            this.multipleSelection = val
        },
    },

    created() {
        this.load()
        this.breadcrumb_teb.name='cl4Face-user'
        this.breadcrumb_teb.pageFlag = 1
        this.breadcrumb_teb.machine = this.machine
        this.breadcrumb_teb.model = 'cl4Face'
        this.breadcrumb_teb.path = '/cl4Face'
        this.$store.commit('clearTabsListExceptFirst')
        this.$store.commit('updateSecondTab',this.breadcrumb_teb)
    },
    watch: {
        machineID(newVal, oldVal) {
            this.machine= this.$store.state.teb.machineID,
            this.gender = ''
            this.age =''
            this.userName =''
            this.pageNum =1
            this.pageSize=10
            this.userID = ''
            this.date =''
            this.load()
        },
    },
    computed: {
        machineID() {
            return this.$store.state.teb.machineID; // 注意这里的命名
        },
    },
}

</script>